import { render, staticRenderFns } from "./task_bulk.vue?vue&type=template&id=5fda234a&scoped=true"
import script from "./task_bulk.vue?vue&type=script&lang=js"
export * from "./task_bulk.vue?vue&type=script&lang=js"
import style0 from "./task_bulk.vue?vue&type=style&index=0&id=5fda234a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fda234a",
  null
  
)

export default component.exports